import Vue from 'vue'
import Vuex from 'vuex'
import modal from '@/store/modules/modal'
import map from '@/store/modules/map'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        modal,
        map
    },
    strict: debug,
})